import { createStyles } from '@mantine/styles';


export default createStyles((
    theme: {
        colors: { [x: string]: any[] };
        other: any;
        spacing: any;
        colorScheme: any;
        shadows: any;
        radius: any;
        fn: any;
    }) => ({

    h3: {
        letterSpacing: 0.6,
        color: theme.colorScheme === 'dark' ? theme.colors.gray[5] : theme.colors.dark[4],
    },

    links: {
        'a': {
            fontSize: 12,
            fontWeight: 400,
            color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.dark[9],
        },

        'a:hover': {
            color: theme.colors.orange[5],
            textDecoration: 'none',
        },
    },

    thingsGridCol: {
        [theme.fn.smallerThan('sm')]: {
            marginTop: 20,
        },
    },

}));
